<template>
	<div class="centerWidth">
		<div class="gaokao-nav">
			<span @click="goMyCenter">个人中心 ></span>
			<span>填:同分数考生去向</span>
		</div>

		<div class="login">
			<h1>基本信息</h1>

			<section class="login_nei login_neiForm">
				<form action="">
					<ul>
						<li class="zhong float flex">
							<label>生源地：</label>
							<div class="regsit_div">
								<el-select v-model="cityName" placeholder="请选择生源地" class="yuanXz">
									<el-option v-for="item in cityList" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
								</el-select>
							</div>
						</li>
						<li class="zhong float flex">
							<label>科目：</label>
							<div class="regsit_div">
								<el-select v-model="value" placeholder="请选择科目" class="years">
									<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>
							</div>
						</li>
						<li class="zhong float flex">
							<label>高考分数：</label>
							<div class="regsit_div">
								<div class="login_input flex zhong "><input type="number" placeholder="请输入" v-model="Score" /></div>
							</div>
						</li>
						<li class="zhong float flex">
							<label></label>
							<div class="regsit_div"><el-button type="primary" class="btn" @click="goDetails()">下一步</el-button></div>
						</li>
					</ul>
				</form>
			</section>
		</div>
	</div>
</template>
<script>
import 'vue-area-linkage/dist/index.css';
import { pca, pcaa } from 'area-data';
import { mapState } from 'vuex';
export default {
	name: 'login',
	data() {
		return {
			options: [
				{
					value: '文科',
					label: '文科或选历史'
				},
				{
					value: '理科',
					label: '理科或选物理'
				},
				{
					value: '不分文理',
					label: '不分文理'
				}
			],
			value: '',
			cityList: [],
			cityName: '',
			pca: pca,
			pcaa: pcaa,
			Score: ''
		};
	},
	computed: {
		...mapState(['user', 'shop'])
	},
	// 加载
	created() {
		this.$store.state.shop.currentProvince.map(ent => {
			if (ent.Code === this.$store.state.user.user.ProvinceCode.toString()) {
				this.cityList.push(ent);
			}
		});
		if (this.cityList.length > 0) {
			this.cityName = this.cityList[0].Code;
		}
		if (this.$route.query.key) {
			this.$api.reduceUserCount({ key: this.$route.query.key });
		} else {
			this.$router.back(-1);
		}
		console.log(this.cityList);
	},
	methods: {
		// 个人中心
		goMyCenter() {
			this.$router.push('/myIndex');
		},
		goDetails() {
			if (this.cityName === '') {
				this.$util.showError('请选择生源地');
				return;
			}
			if (this.value === '') {
				this.$util.showError('请选择科目');
				return;
			}
			if (this.Score === '') {
				this.$util.showError('请输入分数');
				return;
			}

			var name = '';
			this.cityList.map(itme => {
				if (itme.Code === this.cityName) {
					name = itme.Name;
				}
			});
			console.log('name=' + name);
			this.$router.push({ path: '/goDetails', query: { cityName: this.cityName, Name: name, typeId: this.value, score: this.Score } });
		}
	}
};
</script>
<style scoped>
* >>> .area-select.medium {
	margin-left: 0;
	height: 40px;
	line-height: 40px;
	margin-right: 10px;
	border-color: #333;
}

* >>> .area-select.medium {
	width: 106px;
}

* >>> .area-selectable-list .area-select-option.selected {
	color: #333;
}

* >>> .area-select.medium span {
	padding-top: 0;
	padding-bottom: 0;
}

* >>> .area-select-wrap {
	display: flex;
}

.gaokao-nav {
	width: 100%;
	display: flex;
	align-items: center;
	padding: 20px 0 0 0;
}
.gaokao-nav span {
	font-size: 15px;
	color: #333;
}
.gaokao-nav span:last-child {
	color: #333;
}

.login_neiForm .btn {
	width: calc(100% - 100px);
}

.regsit_div p {
	width: calc(100% - 100px);
	font-size: 14px;
	color: #ff0000;
}

.regsit_city {
	overflow: hidden;
	width: 32%;
}

/* regsit_city */

.years {
	width: calc(100% - 100px);
}

* >>> .el-input__inner {
	color: #333;
}

* >>> .el-input__inner,
* >>> .el-input__inner:hover {
	border-color: #333;
}

.regsit_radio {
	margin-right: 3em;
}

.regsit_radio label {
	margin-left: 10px;
	width: auto !important;
}

.regsit_div .login_input {
	width: calc(100% - 98px);
	margin-bottom: 0;
}

.regsit_div {
	width: calc(100% - 98px);
}

/*regsit_div*/

.login_neiForm ul li label span {
	color: #ee0a24;
}

.login_neiForm ul li label {
	width: 90px;
	text-align: right;
	font-size: 14px;
}

.login_neiForm ul li {
	margin-bottom: 20px;
}

.login_neiForm {
	width: 422px !important;
}

/*login_neiForm*/

.login_nei hgroup span {
	font-size: 14px;
	color: #999;
	position: relative;
	padding-left: 20px;
	cursor: pointer;
}

.login_nei hgroup span:hover {
	opacity: 0.7;
}

.login_nei hgroup {
	overflow: hidden;
	margin-top: 20px;
}

.sendCode {
	overflow: hidden;
	width: 180px;
	font-size: 14px;
	color: #333;
	position: relative;
	text-align: center;
	cursor: pointer;
}

.sendCode::after {
	content: '';
	width: 2px;
	height: 14px;
	background-color: #333;
	position: absolute;
	left: 0;
	top: 50%;
	margin-top: -7px;
	z-index: 1;
}

/*sendCode*/

.regsit_yan {
	margin-bottom: 20px;
	overflow: hidden;
	border-radius: 4px;
	height: 40px;
	border: solid 1px #06222c;
	width: 90px;
	box-sizing: border-box;
	cursor: pointer;
}

.regsitFlex .login_input {
	width: calc(100% - 100px);
}

.regsitFlex {
	overflow: hidden;
}

/*regsitFlex*/

.btn {
	display: block;
	width: 100%;
	background-color: #333;
	border-color: #333;
	cursor: pointer;
}

.login_box p span {
	color: #333;
	cursor: pointer;
}

.login_box p {
	font-size: 14px;
	margin-left: 0.5em;
}

.login_box {
	margin-bottom: 30px;
}

/*login_box*/

.login_input input::-webkit-input-placeholder,
* >>> .el-input__inner::-webkit-input-placeholder {
	color: #999;
}
.login_input input:-moz-placeholder,
* >>> .el-input__inner::-moz-placeholder {
	color: #999;
}
.login_input input:-ms-input-placeholder,
* >>> .el-input__inner::-ms-input-placeholder {
	color: #999;
}

.login_input input {
	overflow: hidden;
	width: calc(100% - 30px);
	padding-left: 10px;
	font-size: 14px;
	color: #333;
	display: block;
	height: 100%;
	position: relative;
}

.login_input img {
	display: block;
	width: 20px;
	height: 20px;
}

.login_input {
	margin-bottom: 20px;
	overflow: hidden;
	border-radius: 4px;
	height: 40px;
	border: solid 1px #06222c;
	padding: 0 10px;
	width: 100%;
	box-sizing: border-box;
}

.login_nei {
	width: 340px;
	margin: 60px auto 0 auto;
}

/*login_nei*/

.login h1::after {
	content: '';
	width: 160px;
	height: 6px;
	background-color: #333;
	position: absolute;
	left: 50%;
	margin-left: -80px;
	bottom: 0;
	z-index: 1;
}

.login h1 {
	padding: 10px 0 30px 0;
	overflow: hidden;
	border-bottom: solid 2px #333;
	font-size: 18px;
	color: #333;
	text-align: center;
	position: relative;
}

.login {
	overflow: hidden;
	width: 1200px;
	margin: 40px auto;
	background-color: #fff;
	padding: 20px;
	min-height: 50vh;
}

.area-select-wrap {
}
</style>
